<template>
	<v-card class="buy-with-confidence" elevation="0" :ripple="false">
		<v-img :src="require('@/assets/bg/BuyWithConfidenceZoomed.png')"  position="top"/>
		<v-img :src="require('@/assets/payment-methods.png')" class="paymentMethods" position="bottom"/>
		<div class="text-panel">
			<h4 class="header">Buy with confidence</h4>
			<p class="description">Experience seamless transactions with our secure payment options. Your financial safety is our top priority.</p>
		</div>
	</v-card>
</template>

<script>
export default {
	name: "BuyWithConfidenceShoutPanel"
}
</script>

<style scoped>
.buy-with-confidence {
	border-radius: 12px;
	overflow: hidden;
	height: 295px;
	position: relative;
}

.buy-with-confidence:hover,
.buy-with-confidence:active,
.buy-with-confidence.v-card--hover,
.buy-with-confidence.v-card--active {
	background: inherit !important;
	box-shadow: none !important;
}

.text-panel {
	background: #E8E3E2;
	padding: 20px;
	color: #413655;
	padding-bottom: 32px !important;
}

.text-panel p {
	margin: 0;
	font-size: 14px;
	line-height: 1.4;
}

.header {
	margin: 0;
	font-size: 16px;
	margin-bottom: 8px;
}

.description {
	margin: 0;
	font-size: 14px;
}

.paymentMethods {
	position: absolute;
	width: 200px;
	margin-top: -30px;
	margin-left: 20px;
}

</style>